<template>
    <div v-if="event.provider ? event.provider.includes('survey') : false">
        <div class="question-actions">
            <SurveyHistory
                v-if="event.modified_time"
                :id="event.id"
                :event="event"
                :patient="patient"
                :question="question">
            </SurveyHistory>
            <el-button class="edit-button" @click="showEdit = !showEdit">
                <EditSurveyIcon></EditSurveyIcon>
            </el-button>
        </div>
        <el-dialog :append-to-body="true"
            class="send-now-modal edit-question-modal"
            :visible.sync="showEdit"
            :close-on-click-modal="false"
            :before-close="closePopup">
            <span slot="title"> Edit answer </span>
            <div class="question-title">
                {{qNum + "."}} {{ question.title }} <span class="question-content">({{ question.question }})</span>
            </div>
            <div class="flex-cont">
                <div class="date inl">
                    {{ qDate }}
                </div>
                <div class="inl">
                    <el-rate
                        v-model="updateResponse"
                        @change="onResponseChange()"
                        :texts="['Very Bad', '', '', '', 'Very Good']"
                        :colors="['#709f34', '#709f34', '#709f34']"
                        show-text>
                    </el-rate>
                    <span v-if="(updateResponse == null || updateResponse == undefined || updateResponse == '')" class="no-answer">
                        Not Answered
                    </span>
                </div>
            </div>
            <div class="footer">
                <div class="remove-response" v-if="showRmvResp">
                    <RemoveResponseIcon></RemoveResponseIcon>
                    <span @click="removeResponse()">Remove Response</span>
                </div>
                <div class="mandatory-quest" v-if="checkIfMandatory()"> 
                    <span>
                        * Mandatory
                    </span>
                </div>
                <el-button type="text" size="small" class="cancel-button" @click="closePopup()">
                    Cancel
                </el-button>
                <LoadingButton
                        type="primary"
                        size="small"
                        class="send-button"
                        :disabled="!enableSave"
                        @click="updateQuestion"
                        :loading="savingEdit">
                    Save
                </LoadingButton>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import QuestionEdit from './'
import Icons from '../analysis/response/icon'

export default {
    name: 'edit-star',
    extends: QuestionEdit,

    data() {
        return {
            updateResponse: this.getQuestionResponse(),
            enableSave: false,
            showRmvResp: !this.checkIfMandatory() && this.response,
        }
    },

    methods: {
        ...mapActions('provider', [
            'updateSurvey'
        ]),
        closePopup() {
            this.showEdit = false
            this.enableSave = false
            this.updateResponse = this.getQuestionResponse()
            this.showRmvResp = !this.checkIfMandatory() && this.response
        },
        removeResponse() {
            this.updateResponse = null
            this.showRmvResp = false
            this.enableSave = this.checkIfMandatory() ? false : true
        },
        onResponseChange() {
            if(this.updateResponse != null || this.updateResponse != undefined) {
                    this.enableSave = true
                    this.showRmvResp = this.checkIfMandatory() ? false : true
            } else {
                this.enableSave = this.checkIfMandatory() ? false : true
                this.showRmvResp = false
            }
        },
        updateQuestion() {
            let update = [...this.event.question]
            if(this.updateIndex !== -1)
                update[this.updateIndex] = this.getQuestionUpdate()
            else
                update.push(this.getQuestionUpdate())
            console.log('Index - ',this.updateIndex)
            console.log(update)
            //return
            this.savingEdit = true
            this.updateSurvey({
                updateObj: {
                    id: this.event.response,
                    update
                }, 
                surveyId: this.event.id,
                provider: this.event.provider.split(':')[0],
                patient: this.patient.id,
                previousObj: this.event
                })
                .finally(() => {
                    this.savingEdit = false
                    this.showEdit = false
                    this.enableSave = false,
                    // this.updateResponse = this.getQuestionResponse()
                    this.showRmvResp = !this.checkIfMandatory() && this.response
                })
        },
        getQuestionResponse() {
            if(!this.response)
                return ''
            switch (this.question.type) {
                case 'star': {
                    if(this.oresponse && Array.isArray(this.oresponse) && this.oresponse.length > 0)
                        return parseInt(this.oresponse[0].value) + 1
                    else if(this.oresponse && typeof this.oresponse === 'object') {
                        return parseInt(Object.values(this.oresponse)[0])
                    } else {
                        return 0
                    }
                }
                default:
                    return null
            }
        },
        getOptionObject(selectedValue) {
            return JSON.parse(JSON.stringify(this.question.options.find(({value}) => value == selectedValue)))
        },
        getQuestionUpdate() {
            let update = {
                id: this.question.id,
                answer: null
            }
            switch (this.question.type) {
                case 'star':
                    update.answer = this.updateResponse ? [this.getOptionObject(this.updateResponse - 1)] : null
                    break
            }
            return update
        },
    },

    computed: {
        // isMultipleSelect() {
        //     return ['box_select', 'large_image_select', 'small_image_select', 'select', 'long_text_bubble'].includes(this.question.type)
        // },
        // maxSelectLimit() {
        //     return this.question.single ? 1 : 0
        // }
    },

    components: {
        ...Icons
    }

}
</script>

<style lang="scss" scoped>
@import './style.scss';

div.el-rate {
    display: inherit;
    margin: 11px 10px;
}
</style>
